<template>
  <div class="afm-subscribe-container">
    <p class="sub-header">{{ $t('subscribe_more_info') }}</p>
    <div class="sub-button-container">
      <!-- <a class="button-title">Enter your Email</a> -->
      <input
        type="text"
        :placeholder="$t('enter_email')"
        v-model="subscribeEmail"
        class="subscribe-field"
      />
      <div v-if="subscribeEmailStatus === 'default'" @click="subscribe" class="icon-container">
        <!--              <font-awesome-icon icon="paper-plane" :style="{ color: '#E9C34B', fontSize: '28px' }"/>-->
        <img src="../../assets/img/enter-hover.svg"/>
      </div>
      <div v-if="subscribeEmailStatus === 'success'" class="icon-container">
        <i class="fa fa-check" aria-hidden="true" :style="{ color: '#E9C34B', fontSize: '26px', cursor: 'default' }"></i>
      </div>
      <div v-if="subscribeEmailStatus === 'error'" class="icon-container">
        <i class="fa fa-times" aria-hidden="true" :style="{ color: '#FA6400', fontSize: '26px', cursor: 'default' }"></i>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "subscribe",
  data() {
    return {
      subscribeEmail: '',
      subscribeEmailStatus: 'default',
    }
  },
  methods: {
    ...mapActions('profile', ['fetchSubscribeEmail', 'postSubscribeEmail', 'putUnsubscribeEmail']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    subscribe() {
      if (this.subscribeEmail) {
        if (this.validEmail(this.subscribeEmail)) {
          this.postSubscribeEmail(this.subscribeEmail)
            .then(res => {
              this.subscribeEmailStatus = 'success';
            }).catch(err => {
            this.subscribeEmailStatus = 'error';
            setTimeout(() => {
              this.subscribeEmailStatus = 'default';
            }, 800);
          });
        } else {
          this.subscribeEmailStatus = 'error';
          setTimeout(() => {
            this.subscribeEmailStatus = 'default';
          }, 800);
        }
      }
    }
  }
}
</script>

<style lang="less">
.afm-subscribe-container {
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  .sub-header {
    font-family: 'Source Sans Pro';
    font-size: 20px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #E9C34B;
    margin-bottom: 25px;
  }

  .sub-button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 360px;
    background: #380D64;
    border-radius: 50px;
    padding: 10px;
    // box-shadow: 1px 2px 7px 3px rgba(124, 194, 106, 0.35);
    ::placeholder {
      font-size: 24px;
      font-family: 'Source Sans Pro';
      color: white !important;
    }

    input[type="text"] {
      font-family: 'Source Sans Pro';
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: white !important;
      margin-left: 15px;
      ::placeholder {
        font-size: 24px;
        font-family: 'Source Sans Pro';
        color: white !important;
      }
    }
    .subscribe-field {
      width: 85%;
      background: #380D64;
      border: none;
      margin-left: 40px;
    }
    .subscribe-field:focus {
      outline: none;
    }
    .button-title {
      font-family: 'Source Sans Pro';
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ffffff;
      margin-left: 40px;
    }
    .icon-container {
      height: 50px;
      width: 50px;
      border-radius: 100%;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
      // margin-left: 20px;
      :hover {
        cursor: pointer
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .footer-subscribe {
    width: 35%;
    .sub-button-container {
      width: 280px;
      ::placeholder {
        font-size: 18px;
      }
      .icon-container {

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/afw-subscribe/afw-subscribe.vue